import type {SonataDatabase} from './db.js';
import type {JournalPolicy} from './journalRepository.js';
const LEASE_MS=24*60*60*1000,MAX_BYTES=64*1024*1024,MAX_ENTRIES=64;
export class PhotoMediaCache {
 constructor(private database:SonataDatabase,private policy:()=>JournalPolicy,private current:()=>boolean,private denied:()=>Promise<void>,private now=()=>Date.now()){}
 private check(scope:string){if(!this.current()||scope!==this.policy().scope||!this.policy().active)throw new Error('Photo access changed.');}
 async get(url:string,revision:string,load:()=>Promise<Blob>,online:boolean){
  const scope=this.policy().scope,key='journal-media:'+encodeURIComponent(url)+':'+encodeURIComponent(revision);this.check(scope);
  const query=new URL(url,'https://sonata.invalid').searchParams;
  if(query.get('ephemeral')==='1'||['camera','place'].includes(query.get('audience')||'')){
   try{await this.database.workspaceMeta.delete(key);}catch{this.check(scope);}this.check(scope);
   if(!online)throw new Error('Connect to load this protected photo.');
   const blob=await load();this.check(scope);return blob;
  }
  if(online)try{
   const blob=await load();this.check(scope);
   if(blob.type.startsWith('image/')&&blob.size<=8*1024*1024){
    try{await this.database.transaction('rw',this.database.workspaceMeta,async()=>{
     this.check(scope);await this.database.workspaceMeta.put({key,value:{scope,expires:this.now()+LEASE_MS,used:this.now(),blob}});
     const entries=(await this.database.workspaceMeta.where('key').startsWith('journal-media:').toArray()).sort((a,b)=>b.value.used-a.value.used);
     let bytes=0,count=0;const remove=[];
     for(const row of entries){bytes+=row.value.blob.size;count++;if(bytes>MAX_BYTES||count>MAX_ENTRIES||row.value.expires<=this.now())remove.push(row.key);}
     await this.database.workspaceMeta.bulkDelete(remove);
     this.check(scope);
    });}catch{this.check(scope);}
   }
   this.check(scope);return blob;
  }catch(error){
   this.check(scope);if((error as any)?.status&&![408,429,500,502,503,504].includes((error as any).status)){if([403,404].includes((error as any).status))await this.denied();throw error;}
   if((error as any)?.name==='AbortError')throw error;
  }
  const saved=(await this.database.workspaceMeta.get(key))?.value;this.check(scope);
  if(saved?.scope===scope&&saved.expires>this.now())return saved.blob as Blob;
  if(saved)await this.database.workspaceMeta.delete(key);
  throw new Error('Connect to load this photo.');
 }
}
